// Save public key to check balances anywhere
import React, { useState } from "react"

const UserContext = React.createContext({
  publicKey: "",
})

const UserProvider = ({ children }) => {
  const [publicKey, setPublicKey] = useState("")

  return (
    <UserContext.Provider value={{ publicKey, setPublicKey }}>
      {children}
    </UserContext.Provider>
  )
}

export default UserContext

export { UserProvider }
